import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Matches from "@/pages/Matches";
import Navigator from "@/pages/Navigator";
import Hub from "@/pages/Hub";
import Messages from "@/pages/Messages";
import Analytics from "@/pages/Analytics";
import PremiumSuccess from "@/pages/PremiumSuccess";
import Invite from "@/pages/Invite";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import Press from "@/pages/Press";
import Privacy from "@/pages/Privacy";
import Accessibility from "@/pages/Accessibility";
import Vpat from "@/pages/Vpat";
import AppShell from "@/components/AppShell";
import CookieConsent from "@/components/CookieConsent";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return <AppShell>{children}</AppShell>;
};

const OnboardingGate = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
};

export default function App() {
  return (
    <div className="App">
      <a href="#main-content" className="skip-to-content" data-testid="skip-to-content">
        Skip to main content
      </a>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/press" element={<Press />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/accessibility/vpat" element={<Vpat />} />
            <Route path="/invite/:code" element={<Invite />} />
            <Route path="/onboarding" element={<OnboardingGate><Onboarding /></OnboardingGate>} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/matches" element={<Protected><Matches /></Protected>} />
            <Route path="/app/navigator" element={<Protected><Navigator /></Protected>} />
            <Route path="/app/hubs/:condition" element={<Protected><Hub /></Protected>} />
            <Route path="/app/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/app/analytics" element={<Protected><Analytics /></Protected>} />
            <Route path="/app/premium/success" element={<OnboardingGate><PremiumSuccess /></OnboardingGate>} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}
